
// src/connects/members-page.js

import { connect } from 'react-redux'
import lifecycle from '../helpers/lifecycle'
import { translate } from 'react-i18next'
import actions from '../actions'
import { emitAlertMessage } from '../actions/alert-message'
import combineHOC from '../helpers/combine-hoc'
import { trackPage } from '../helpers/analytics'
import find from 'lodash/find'
import ui from '../helpers/ui-state'

export const mapStateToProps = (state, ownProps)=> {
  return {
    user: state.user.current,
    favoriteUsers: state.favorite.users,
    group: ownProps.params.group_id && find(state.groups.items, (item)=> item.group_id == ownProps.params.group_id) || undefined,
    isFetching: state.groups.isFetching,
    blockUsers: state.block.users
  }
}

export const mapDispatchToProps = (dispatch)=> {
  return {
    openGroupProfilePanel: ()=> dispatch(actions.openGroupSettingsPage('profile')),
    openUserProfilePanel: ()=> dispatch(actions.openUserSettingsPage('profile')),
    isFavorite: (user, props)=> !!find(props.favoriteUsers, (_user)=> _user.user_id == user.user_id),
    toggleFavoriteUser: (user, isFavorite)=> {
      dispatch(actions.updateFavoriteUser(user.user_id, !isFavorite))
      dispatch(emitAlertMessage({ message: !isFavorite ? 'label:お気に入りユーザに追加しました' : 'label:お気に入りユーザから削除しました', name: user && user.name }, 'success'))
    },

    willMount: (props)=> {
      dispatch(actions.fetchFavoriteUsers())
      if (!props.group || !props.group.members)
        dispatch(actions.fetchGroup(props.params.group_id))
    }
  }
}

export default combineHOC(
  connect(mapStateToProps, mapDispatchToProps),
  ui({ 
    state: { 
      showAll: false,
      is_details: false,
      is_summary: false,
      user: undefined,
      is_pc: false,
      show_summary: false,
    }}),
  lifecycle,
  translate(),
  trackPage('members'),
)



// WEBPACK FOOTER //
// ./src/connects/members-page.js